/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { isDevelopment } from '../../constants/settings';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import {useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { DataSourceHandler } from '@api/data-source-handler';
import { Modal } from 'antd';
import { errorAlert, successAlert } from '@components/toastify/notify-toast';

export const AirFLow = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const dagId = searchParams.get('dagId');
    const [loadIframe, setLoadIframe] = React.useState(false);
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
    const baseUrl = isDevelopment ? "https://airflow.3535353535.deepiq.com" : Env?.REACT_APP_AIRFLOW_URL?.replace(/\/home$/, "");
    const redirectAirflowUrl = isEmpty(dagId) ? `${baseUrl}/home` : `${baseUrl}/dags/${dagId}/grid`;

    useEffect(() => {
        setTimeout(() => setLoadIframe(true), 500);
    }, []);

    useEffect(() => {
        const handler = (event: MessageEvent) => {
          if (event.data?.type === 'deleteRequested' && event.data.dagId) {
            const dagId = event.data.dagId;

            if (dagId.startsWith('model-request')) {
              errorAlert('This DAG is associated with PI-integrator, so deletion is not allowed.');
              return;
            }

            Modal.confirm({
              title: 'Delete DAG?',
              content: `Are you sure you want to delete DAG "${dagId}"?`,
              okText: 'Yes, Delete',
              cancelText: 'Cancel',
              okButtonProps: { style: { backgroundColor: '#FF4D4F', borderColor: '#FF4D4F' } },
              onOk: () => {
                DataSourceHandler.DeleteDagAirflow(
                  `${Env?.REACT_APP_PLATFORM_URL}/airflow/api`,
                  dagId,
                  (res) => {
                    successAlert(`${res}. It would take a few minutes to reflect in the Airflow UI`);
                  },
                  (e: any) => {
                    console.error('Error deleting DAG:', e);
                    errorAlert(e?.response?.data?.message || e?.message || 'Error deleting DAG');
                  }
                );
              },
              onCancel: () => {
                console.log('Deletion canceled for DAG:', dagId);
              },
            });
          }
        };

        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
      }, []);


    return (
        Env?.REACT_APP_DISABLE_AIRFLOW ?
            <div
                className="disableMlFlow__box"
            >
                <h2>Airflow is not deployed on this environment<br />Contact DeepIQ </h2>

            </div>
            :
            (loadIframe && <iframe
                className='iframe'
                style={{
                    width: 'calc(100% - 72px)',
                    height: 'calc(100vh - 54px)',
                    marginLeft: '72px',
                    marginTop: '54px',
                    border: 'none',
                    backgroundColor: 'rgb(4, 6, 20)'
                }}
                src={redirectAirflowUrl}
                loading="lazy"
            >
            </iframe>)
    );
};
